module.exports = __webpack_public_path__ + "img/DE01474.adf26ba3.png";